import { Event } from "react-pluggable";

export class PluginEvent extends Event {
    data?: any
    constructor(name: string, data?: any) {
        super(name);
        this.data = data;
    }
}